import { axios } from '@Root/API'

export const get = contactId => {
	return axios.get(`contact/${contactId}/cleric`)
}
